import { Shield, Phone, CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

const Hero = () => {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden gradient-subtle py-20">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="space-y-4">
              <div className="flex items-center gap-2 text-trust">
                <Shield className="h-6 w-6" />
                <span className="text-sm font-medium uppercase tracking-wider">
                  {t('hero.tagline')}
                </span>
              </div>
              <h1 className="text-5xl lg:text-6xl font-bold leading-tight">
                {t('hero.title').split(t('hero.titleHighlight'))[0]}
                <span className="text-primary">{t('hero.titleHighlight')}</span>
                {t('hero.title').split(t('hero.titleHighlight'))[1]}
              </h1>
              <p className="text-xl text-muted-foreground max-w-lg">
                {t('hero.description')}
              </p>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                variant="hero" 
                size="xl" 
                className="shadow-glow"
                onClick={() => {
                  const pricingSection = document.getElementById('preise');
                  pricingSection?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <Shield className="mr-2 h-5 w-5" />
                {t('hero.cta.primary')}
              </Button>
              <Button 
                variant="outline" 
                size="xl"
                onClick={() => window.location.href = 'tel:+4915258970017'}
              >
                <Phone className="mr-2 h-5 w-5" />
                {t('hero.cta.secondary')}
              </Button>
            </div>
            
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pt-8 place-items-center">
              <div className="flex items-center gap-2">
                <CheckCircle className="h-5 w-5 text-success flex-shrink-0" />
                <span className="text-sm">{t('hero.features.hotline')}</span>
              </div>
              <div className="flex items-center gap-2">
                <CheckCircle className="h-5 w-5 text-success flex-shrink-0" />
                <span className="text-sm">{t('hero.features.aiDetection')}</span>
              </div>
              <div className="flex items-center gap-2">
                <CheckCircle className="h-5 w-5 text-success flex-shrink-0" />
                <span className="text-sm">{t('hero.features.smartphoneHelp')}</span>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <img 
              src="/images/hero-seniors.jpg"
              alt={t('hero.imageAlt')}
              width={1920}
              height={1080}
              fetchPriority="high"
              className="rounded-2xl shadow-soft w-full h-auto"
            />
            <div className="absolute -bottom-4 -right-4 bg-accent text-accent-foreground p-4 rounded-xl shadow-soft">
              <div className="flex items-center gap-2">
                <Shield className="h-6 w-6" />
                <div>
                  <div className="font-bold">{t('hero.badge.title')}</div>
                  <div className="text-sm opacity-90">{t('hero.badge.subtitle')}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;